import React from 'react';

export interface ProMetaRowProps {
  /** Optional leading icon (Lucide or IonIcon). */
  leadingIcon?: React.ReactNode;
  /** Inline segments joined with · (falsy entries are omitted). */
  segments?: Array<React.ReactNode | null | undefined | false>;
  /** Right-aligned trailing text (e.g. time ago). */
  trailing?: React.ReactNode;
  className?: string;
}

/**
 * Compact metadata row shared by Pro dashboard cards (Hot Bills sponsor/client,
 * Latest News source/time, etc.). Always renders at 11px tertiary text.
 */
const ProMetaRow: React.FC<ProMetaRowProps> = ({
  leadingIcon,
  segments = [],
  trailing,
  className = '',
}) => {
  const visibleSegments = segments.filter(
    (segment) => segment !== null && segment !== undefined && segment !== false,
  );

  if (visibleSegments.length === 0 && !leadingIcon && !trailing) {
    return null;
  }

  return (
    <div
      className={`pro-meta-row flex items-center gap-1.5 min-w-0 text-[11px] text-text-tertiary dark:text-text-dark-tertiary ${
        trailing ? 'justify-between' : ''
      } ${className}`}
    >
      <div className="flex items-center gap-1.5 min-w-0 flex-1">
        {leadingIcon && <span className="flex-shrink-0">{leadingIcon}</span>}
        {visibleSegments.map((segment, index) => (
          <React.Fragment key={index}>
            {index > 0 && <span className="flex-shrink-0">·</span>}
            <span className={`truncate ${index === 0 && trailing ? 'font-medium' : ''}`}>
              {segment}
            </span>
          </React.Fragment>
        ))}
      </div>
      {trailing && <span className="flex-shrink-0 ml-2">{trailing}</span>}
    </div>
  );
};

export default ProMetaRow;
